import { LuSearch } from "@/Components/Icons/Icons";

export default {
  row1 :[
  {
    column: "column1",
    rows: {
      row1: [
        {
          name: "deecItemsnopartC",
          label: "Item SNo Part C",
          component: "text-field",
          icon: LuSearch,
          required : true
        },
         {
          name: "deecItemType",
          label: "Item type",
          component: "dropdown",
          endIconName: "LuChevronDown",
          options: [
            { label: "Imported", value: "Imported" },
            { label: "Indigenous", value: "Indigenous" }
          ],
        },
      ],
      row2: [
        {
          name: "deecItemDescription",
          label: "Description",
          component: "text-field",
        },
      ],
      row3:[
        {
          name: "deecItemQuantity",
          label: "Quantity",
          component: "text-field",
        },
        {
          name: "deecItemQuantityUnit",
          label: "Unit",
          component: "text-field",
          type : "autocomplete",
          endpoint: "getQuantity",
        },
      ]
    },
  },
]
};
